export const eLearningUrl = new URL('https://share.articulate.com/sWW2FkLDelBMaOh7yCTwA');

export class TGAAIIdentifiers {
  protected static readonly identifier = 'TGA';
}

export class Insights extends TGAAIIdentifiers {
  protected static readonly baseIdentifier = `${TGAAIIdentifiers.identifier}.Insights` as const;

  static clickedWarning(type: string) {
    return `${this.baseIdentifier}.Warning.Clicked.Type.${type}`;
  }
  static clickedNotification(type: string) {
    return `${this.baseIdentifier}.Notification.Clicked.Type.${type}`;
  }

  static get clickedWaterAuthority() {
    return `${this.baseIdentifier}.Waterauth.Clicked.i`;
  }

  static get cropAdviceDetails() {
    return `${this.baseIdentifier}.CropAdvices.DetailsOpened`;
  }
}

export class CropFieldSelection extends TGAAIIdentifiers {
  protected static readonly baseIdentifier = `${TGAAIIdentifiers.identifier}.CropFieldSelection` as const;

  static get pageViewed() {
    return `${this.baseIdentifier}.PageViewed`;
  }

  static tabSelected(tabName: string) {
    return `${this.baseIdentifier}.Tab.Selected.${tabName}`;
  }

  static get adviceItemOpened() {
    return `${this.baseIdentifier}.Advice.Item.Opened`;
  }

  static get questionnaireItemOpened() {
    return `${this.baseIdentifier}.Questionnaire.Item.Opened`;
  }

  static get genericQuestionnaireOpened() {
    return `${this.baseIdentifier}.Questionnaire.Generic.Opened`;
  }
}

export class Advice extends TGAAIIdentifiers {
  protected static readonly baseIdentifier = `${TGAAIIdentifiers.identifier}.Advice` as const;

  static get generalAdviceViewed() {
    return `${this.baseIdentifier}.Viewed`;
  }

  static get cultivationAdviceBlightRecalculate() {
    return `${this.baseIdentifier}Cultivation.Action.BlightRecalculate`;
  }

  static get cultivationAdviceEditPlantDate() {
    return `${this.baseIdentifier}Cultivation.Action.BlightPlantDate`;
  }

  static get cultivationAdviceEditEmergenceDate() {
    return `${this.baseIdentifier}Cultivation.Action.BlightEmergenceDate`;
  }

  static get cultivationAdviceEditHarvestDate() {
    return `${this.baseIdentifier}Cultivation.Action.BlightHarvestDate`;
  }

  static get cultivationAdiceShowBEMadviceTrends() {
    return `${this.baseIdentifier}Cultivation.Action.BalansbemestingAdviceTrends`;
  }
}
